import React, { useState, useMemo, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from "../../components/panel/panel";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TablaDetalle from "./components/TablaDetalle";
import TotalizadoresDetalle from "./components/TotalizadoresDetalle";
import InformacionTercero from "./components/InformacionTercero";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import { useDispatch, useSelector } from "react-redux";
import { talonarioActions, comprobanteActions } from "../../store";
import BuildComprobante from "./components/BuildComprobante.js";
import useQuery from "../../helper/useQuery.js";
import { useEffectAsync } from "../../helper/reactHelper";

import _ from "lodash";

import { momentObj, formatDate2Iso } from "../../helper/formatter";

registerLocale("es", es);

const RegistrarFactura = () => {
    let buildComprobante = BuildComprobante();
    const dispatch = useDispatch();

    const mainInput = useRef(null);

    const tipoVentas = useSelector((state) => state.tipoventas.items);
    const originalTercero = useSelector((state) => state.tercero.items);

    const customTercero = useMemo(() => {
        return _(originalTercero)
            .filter("is_cliente")
            .map((v) => ({ value: v.id, label: v.razonsocial }))
            .value();
    }, [originalTercero]);
    const [terceroSelected, setTerceroSelected] = useState(customTercero[0]);

    const originalTalonario = useSelector((state) => state.talonario.items);
    const talonarioDeterminado =
        _.filter(originalTalonario, "predeterminado").length > 0 ? _.filter(originalTalonario, "predeterminado")[0] : null;

    const customTalonario = useMemo(() => {
        return _(originalTalonario)
            .filter((v) => v.activo)
            .filter((v) => _.includes([1, 2, 5], v.tipoComprobanteId))
            .map((v) => ({ value: v.id, label: `${v.tipo_comprobante?.name} - ${v.serie}` }))
            .value();
    }, [originalTalonario]);

    const [talonarioSelected, setTalonarioSelected] = useState(_.filter(customTalonario, ["value", talonarioDeterminado?.id])[0]);
    const [correlativo, setCorrelativo] = useState(originalTalonario[customTalonario[0]?.value]?.proximo_correlativo || "");

    const [fechaEmision, setFechaEmision] = useState(new Date());
    const [detalle, setDetalle] = useState([]);
    const [editRowIndex, setEditRowIndex] = useState(-1);
    const [totalizadores, setTotalizadores] = useState({
        suma_venta_sujeta: 0,
        iva: 0,
        retencion: 0,
        suma_venta_excenta: 0,
        suma_venta_no_sujeta: 0,
        total: 0,
    });

    const [detalleInput, setDetalleInput] = useState({
        cantidad: "",
        descripcion: "",
        precio_unitario: "",
        tipoVentaId: 1,
        venta: "",
    });
    const handleInputDetalle = (event) => setDetalleInput({ ...detalleInput, [event.target.name]: event.target.value });

    const [dias_credito, setDias_credito] = useState(30);

    useEffect(() => {
        setCorrelativo(originalTalonario[talonarioSelected?.value]?.proximo_correlativo || "");
    }, [originalTalonario]);

    useEffect(() => {
        if (editRowIndex == -1) {
            setDetalleInput({ cantidad: "", descripcion: "", precio_unitario: "", tipoVentaId: 1, venta: "" });
        }
    }, [editRowIndex]);

    useEffect(() => {
        let totalizadores_init = {
            suma_venta_sujeta: 0,
            iva: 0,
            retencion: 0,
            suma_venta_excenta: 0,
            suma_venta_no_sujeta: 0,
            total: 0,
        };
        _.each(detalle, (e) => {
            if (e.tipoVentaId == 1) {
                totalizadores_init.suma_venta_sujeta += e.venta;
            } else if (e.tipoVentaId == 2) {
                totalizadores_init.suma_venta_no_sujeta += e.venta;
            } else if (e.tipoVentaId == 3) {
                totalizadores_init.suma_venta_excenta += e.venta;
            }
        });
        totalizadores_init.iva = totalizadores_init.suma_venta_sujeta * 0.13;
        totalizadores_init.retencion =
            originalTercero[terceroSelected?.value]?.is_retencion && totalizadores_init.suma_venta_sujeta >= 100
                ? totalizadores_init.suma_venta_sujeta * 0.01
                : 0;
        totalizadores_init.total =
            totalizadores_init.suma_venta_sujeta +
            totalizadores_init.iva -
            totalizadores_init.retencion +
            totalizadores_init.suma_venta_excenta +
            totalizadores_init.suma_venta_no_sujeta;
        setTotalizadores(totalizadores_init);
    }, [detalle, editRowIndex, terceroSelected]);

    useEffect(() => {
        setDias_credito(originalTercero[terceroSelected?.value]?.diascredito || 30);
    }, [terceroSelected]);

    const handleInputAdd = () => {
        if (!(detalleInput.cantidad == "" && detalleInput.precio_unitario == "")) {
            setDetalle(detalle.concat({ ...detalleInput, ["venta"]: detalleInput.cantidad * detalleInput.precio_unitario }));
        } else {
            setDetalle(detalle.concat({ ...detalleInput, ["tipoVentaId"]: 4 }));
        }
        setDetalleInput({ cantidad: "", descripcion: "", precio_unitario: "", tipoVentaId: 1, venta: "" });
        mainInput.current?.focus();
    };

    const handleInputEdit = () => {
        if (!(detalleInput.cantidad == "" && detalleInput.precio_unitario == "")) {
            detalle[editRowIndex] = { ...detalleInput, ["venta"]: detalleInput.cantidad * detalleInput.precio_unitario };
        } else {
            detalle[editRowIndex] = { ...detalleInput, ["tipoVentaId"]: 4 };
        }
        setDetalle(detalle);
        setDetalleInput({ cantidad: "", descripcion: "", precio_unitario: "", tipoVentaId: 1, venta: "" });
        setEditRowIndex(-1);
    };

    const ActionRowHandler = (action, value) => {
        if (action === "remove") {
            setDetalle(_.filter(detalle, (e, i) => i != value));
        } else if (action === "update") {
            let o = Object.fromEntries(Object.entries(detalle[value]).filter(([_, v]) => v != null));
            setDetalleInput({ cantidad: "", descripcion: "", precio_unitario: "", tipoVentaId: 1, venta: "", ...o });
            setEditRowIndex(value);
            mainInput.current?.focus();
        }
    };

    const registrarComprobanteHanlder = async () => {
        if (!terceroSelected) {
            alert("seleccione un cliente");
            return;
        }
        if (!talonarioSelected) {
            alert("seleccione un tipo de comprobante");
            return;
        }

        let payload = {
            fecha_emision: formatDate2Iso(fechaEmision),
            fecha_vencimiento: momentObj(fechaEmision).add(dias_credito, "days").toISOString(),
            cancelado: false,
            anulado: false,
            n_comprobante: correlativo,
            suma_venta_sujeta: parseFloat(totalizadores.suma_venta_sujeta).toFixed(2),
            suma_venta_excenta: parseFloat(totalizadores.suma_venta_excenta).toFixed(2),
            suma_venta_no_sujeta: parseFloat(totalizadores.suma_venta_no_sujeta).toFixed(2),
            iva: parseFloat(totalizadores.iva).toFixed(2),
            retencion: parseFloat(totalizadores.retencion).toFixed(2),
            importe: parseFloat(totalizadores.total).toFixed(2),
            pendiente: parseFloat(totalizadores.total).toFixed(2),
            dias_credito: dias_credito,
            terceroId: terceroSelected.value,
            is_compra: false,
            is_venta: true,
            talonarioId: talonarioSelected.value,
            detalle_comprobantes: _.map({ ...detalle }, (v1, i) => ({ ..._.mapValues(v1, (v2) => v2 || null), ["linea"]: i })),
        };

        const comprobanteRes = await fetch("/api/comprobante/registrar", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });

        if (comprobanteRes.ok) {
            let nextCorrelativo = parseInt(correlativo) + 1;
            const talonarioRes = await fetch(
                `/api/talonario/actualizar_correlativo/${talonarioSelected.value}/${nextCorrelativo}`,
                { method: "PUT" }
            );
            dispatch(talonarioActions.update([await talonarioRes.json()]));
            dispatch(comprobanteActions.update([await comprobanteRes.json()]));
            buildComprobante({ ...payload });
            setDetalle([]);
        } else {
            throw Error(await comprobanteRes.text());
        }
    };

    // Load comprobante by query
    const comprobantes = useSelector((state) => state.comprobante.items);
    const query = useQuery();
    useEffectAsync(async () => {
        if (query.get("comprobanteId") && comprobantes[query.get("comprobanteId")]) {
            const comprobanteId = query.get("comprobanteId");
            const response = await fetch(`/api/comprobante/${comprobanteId}/DetalleComprobante`);
            let detalleComprobante = [];
            if (response.ok) {
                detalleComprobante = _(await response.json())
                    .sortBy("linea")
                    .map((dc) => {
                        let { comprobanteId, createdAt, id, linea, updateAt, ...res } = dc;
                        return res;
                    })
                    .value();
            }

            let comprobante = comprobantes[comprobanteId];
            setTerceroSelected({ value: comprobante.terceroId, label: originalTercero[comprobante.terceroId].razonsocial });
            setDetalle(detalleComprobante);
        }
    }, [query]);

    return (
        <Panel>
            <PanelHeader>Registrar Comprobante</PanelHeader>
            <PanelBody>
                <div className="row">
                    <div className="col-md-7">
                        <div className="row">
                            <div className="col-md-10 col-9">
                                <label className="form-label">Razon social:</label>
                                <Select
                                    value={terceroSelected}
                                    options={customTercero}
                                    isSearchable
                                    placeholder="Seleccione una razon social"
                                    onChange={(selected) => setTerceroSelected(selected)}
                                />
                            </div>

                            <div className="col-md-2 col-3">
                                <Link to={`/tercero`} className="btn btn-green btn-xs mt-4">
                                    <span className="d-flex align-items-center text-start">
                                        <i className="fas fa-plus me-2 text-black"></i>
                                        <span>
                                            <span className="d-block">Nuevo</span> <span className="d-block">Cliente</span>
                                        </span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                        <InformacionTercero terceroSelected={originalTercero[terceroSelected?.value]} />
                    </div>

                    <div className="col-md-5 ">
                        <div className="row">
                            <div className="col-6 col-md-4 mb-2">
                                <label className="form-label">Fecha emision:</label>
                                <DatePicker
                                    selected={fechaEmision}
                                    dateFormat="dd/MM/yyyy"
                                    locale="es"
                                    onChange={(date) => setFechaEmision(date)}
                                    className="form-control"
                                />
                            </div>

                            <div className="col-6 col-md-4 mb-2">
                                <label className="form-label">Dias de credito:</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={dias_credito}
                                    onChange={(e) => setDias_credito(e.target.value)}
                                />
                            </div>

                            <div className="col-6 col-md-4 mb-2">
                                <label className="form-label">Cond. de venta:</label>
                                <select className="form-select">
                                    <option>CREDITO</option>
                                    <option>CONTADO</option>
                                </select>
                            </div>

                            <div className="col-12 col-md-8 mb-2">
                                <label className="form-label">Tipo comprobante:</label>
                                <Select
                                    value={talonarioSelected}
                                    options={customTalonario}
                                    isSearchable
                                    placeholder="Seleccione tipo de comprobante"
                                    onChange={(selected) => {
                                        setTalonarioSelected(selected);
                                        setCorrelativo(originalTalonario[selected.value].proximo_correlativo);
                                    }}
                                />
                            </div>

                            <div className="col-6 col-md-4 mb-2">
                                <label className="form-label">Correlativo:</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={correlativo}
                                    onChange={(e) => setCorrelativo(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <hr />

                <div className="row">
                    <div className="col-4 col-md-2 mb-2">
                        <label className="form-label">CANTIDAD</label>
                        <input
                            type="number"
                            ref={mainInput}
                            className="form-control"
                            onChange={handleInputDetalle}
                            name="cantidad"
                            value={detalleInput.cantidad}
                        />
                    </div>
                    <div className="col-8 col-md-4 mb-2">
                        <label className="form-label">DESCRIPCION</label>
                        <input
                            type="text"
                            className="form-control"
                            onChange={handleInputDetalle}
                            name="descripcion"
                            value={detalleInput.descripcion}
                        />
                    </div>

                    <div className="col-5 col-md-2 mb-2">
                        <label className="form-label">PRECIO UNITARIO</label>
                        <input
                            type="number"
                            className="form-control"
                            onChange={handleInputDetalle}
                            name="precio_unitario"
                            value={detalleInput.precio_unitario}
                        />
                    </div>

                    <div className="col-5 col-md-2 mb-2">
                        <label className="form-label">TIPO VENTA:</label>
                        <select
                            className="form-select"
                            value={detalleInput.tipoVentaId}
                            onChange={handleInputDetalle}
                            name="tipoVentaId">
                            {_.map(tipoVentas, (item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-1 col-md-2">
                        {editRowIndex >= 0 ? (
                            <div>
                                <button type="button" className="btn btn-primary m-r-5 mt-2 ms-1" onClick={handleInputEdit}>
                                    <i className="fa fa-edit"></i>
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger m-r-5 mt-2 ms-1"
                                    onClick={() => setEditRowIndex(-1)}>
                                    <i className="fa fa-ban"></i>
                                </button>
                            </div>
                        ) : (
                            <button type="button" className="btn btn-success  m-r-5 mt-2" onClick={handleInputAdd}>
                                <i className="fa fa-plus"></i>
                            </button>
                        )}
                    </div>
                </div>

                <TablaDetalle detalle={detalle} actionRow={ActionRowHandler} />
                <TotalizadoresDetalle totalizadores={totalizadores} />

                <hr />
                <div className="row text-center">
                    <div className="col-md-12">
                        <button disabled onClick={() => console.log(" guardar borrados")} className="btn btn-gray me-5px">
                            <span className="d-flex align-items-center text-start">
                                <i className="fas fa-eraser fa-2x me-2 text-black"></i>
                                <span>
                                    <span className="d-block">Guardar borrador</span>
                                </span>
                            </span>
                        </button>

                        <button onClick={registrarComprobanteHanlder} className="btn btn-green">
                            <span className="d-flex align-items-center text-start">
                                <i className="fas fa-print fa-2x me-2 text-black"></i>
                                <span>
                                    <span className="d-block">Registrar comprobante</span>
                                </span>
                            </span>
                        </button>
                    </div>
                </div>
            </PanelBody>
        </Panel>
    );
};

export default RegistrarFactura;
